var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'interact--swipe': true, swiping: _vm.swiping },staticStyle:{"touch-action":"pan-y"},attrs:{"swipe-left":_vm.swipeLeft,"swipe-right":_vm.swipeRight}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }